module.exports = __webpack_public_path__ + "media/images/dog-3f1aa3852ffb0d98610d09e6dab66a45.jpg";